import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { breakpoints } from "plos/src/styles/breakpoints";

export const buttonWrapperStyles = style({
  display: "flex",
  alignSelf: "normal",
  justifyContent: "space-between",
  gap: vars.space.s,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      flex: "0 0 276px",
      alignSelf: "center",
    },
  },
});
